import React from 'react';
import {Icon} from '../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../atoms/Icon/IconName';

export const BellNotificationFallback: React.FC<{
  ref?: React.Ref<HTMLDivElement | null>;
  className?: string;
  style?: React.CSSProperties;
}> = ({ref, className, style}) => {
  return (
    <div ref={ref} className={className} style={style}>
      <Icon asset={GenericIconName.Bell} size="S" />
    </div>
  );
};
